import { createSlice, isAnyOf } from '@reduxjs/toolkit';
import { authExtraActions } from 'reduxStore/actions';
import { generalExtraActions } from 'reduxStore/actions';
import {local, routes} from 'common';
import {toast} from 'react-toastify';

const INITIAL_STATE = {
  loading: false,
  user: local.getUser(),
  isUserLoggedIn: local.isUserLoggedIn(),
  tokens: {
    access: '',
    refresh: '',
  },
  error: null
};

export const authSlice = createSlice({
  name: 'auth',
  initialState: INITIAL_STATE,
  reducers: {
    resetAuthSlice: () => INITIAL_STATE,
    logout: (state,) => {
      state.isUserLoggedIn = false;
      local.clearLocalStorge();
    }
  },
  extraReducers: (builder) => {
    builder.addCase(
      authExtraActions.profilePatch.fulfilled,
      (state, {payload}) => {
        state.loading = false;
        state.user = payload;
        local.storeUser(payload);
        state.error = null;
      }
    );
    builder.addCase(
      authExtraActions.changePassword.fulfilled,
      (state, {payload}) => {
        state.loading = false;
        state.error = null;
      }
    );
    builder.addMatcher(
      isAnyOf(
        authExtraActions.login.fulfilled,
      ),
      (state, {payload}) => {
        const {tokens, user} = payload;
        state.loading = false;
        state.isUserLoggedIn = true;
        state.tokens = tokens;
        state.user = user;
        local.storeUser(user);
        local.storeTokens(tokens);
        state.error = null;
      }
    );
    builder.addMatcher(
      isAnyOf(
        authExtraActions.login.pending,
        authExtraActions.profilePatch.pending,
        authExtraActions.changePassword.pending,
      ),
      (state, {payload}) => {
        state.loading = true;
        state.error = null;
      }
    );
    builder.addMatcher(
      isAnyOf(
        authExtraActions.login.rejected,
        authExtraActions.profilePatch.rejected,
        authExtraActions.changePassword.rejected,
      ),
      (state, {payload}) => {
        state.loading = false;
        state.error = payload;
      }
    );
  },
});

export const {actions: authActions, reducer} = authSlice;
export default reducer;
